<template>
  <b-modal
    v-model="isModalOpened.isOpen"
    :title="getModalTitle"
    size="lg"
    @ok="onOkClick"
  >
    <tabs-component
      :tabs-data="tabsData"
      @get-selected-tab="setSelectedTab"
    />
    <div class="content">
      <general-editor-component
        v-if="selectedTab === 'general'"
        :is-title-visible="isTitleVisible"
        @get-section-name="getSectionName"
        @get-title-visibility="getTitleVisibility"
      />
      <colors-editor-component
        v-if="selectedTab === 'colors'"
        size="large"
        :background-color="backgroundColor"
        :text-color="textColor"
        :border-color="borderColor"
        @get-text-color="getTextColor"
        @get-background-color="getBackgroundColor"
        @get-border-color="getBorderColor"
      />
      <borders-editor-component
        v-if="selectedTab === 'borders'"
        :border-radius="borderRadius"
        :border-style="borderStyle"
        :border-width="borderWidth"
        @get-border-style="getBorderStyle"
        @get-border-width="getBorderWidth"
        @get-border-radius="getBorderRadius"
      />
    </div>
    <section-model
      :section-name="sectionName"
      :is-section-visible="isTitleVisible"
      :border-width="borderWidth"
      :border-color="borderColor"
      :border-radius="borderRadius"
      :border-style="borderStyle"
      :background-color="backgroundColor"
      :text-color="textColor"
    />
  </b-modal>
</template>

<script>

import {createNamespacedHelpers} from 'vuex';
import TabsComponent from '@/modules/DataManagement/views/tableBuilder/components/TabsComponent.vue';
import GeneralEditorComponent
  from '@/modules/DataManagement/views/designer/components/editorComponents/GeneralEditorComponent.vue';
import ColorsEditorComponent
  from '@/modules/DataManagement/views/designer/components/editorComponents/ColorsEditorComponent.vue';
import BordersEditorComponent
  from '@/modules/DataManagement/views/designer/components/editorComponents/BordersEditorComponent.vue';
import SectionModel from '@/modules/DataManagement/views/designer/components/editorComponents/SectionModel.vue';

const {
  mapState: designerMapState,
  mapActions: designerMapActions,
} = createNamespacedHelpers('designer');

const tabsData = [
  {id: 0, label: 'General', value: 'general', icon: 'home'},
  {id: 1, label: 'Colors', value: 'colors', icon: 'palette'},
  {id: 2, label: 'Borders', value: 'borders', icon: 'border-all'},
];
export default {
  name: 'DesignerCustomisationsModal',
  components: {
    SectionModel,
    BordersEditorComponent,
    ColorsEditorComponent,
    GeneralEditorComponent,
    TabsComponent,
  },
  data() {
    return {
      selectedTab: 'general',
      isTitleVisible: true,
      sectionName: '',
      textColor: '#000',
      backgroundColor: '#fff',
      borderWidth: 1,
      borderStyle: 'none',
      borderColor: 'black',
      borderRadius: 0,
      tabsData,
    };
  },
  computed: {
    ...designerMapState({
      isModalOpened: state => state.customisationsModal,
      itemTitle: state => state.customisationsModal.title,
      sectionId: state => state.customisationsModal.sectionId,
      sections: state => state.data.Sections,
    }),
    getModalTitle() {
      return `Customise "${this.itemTitle}" section`;
    },
  },
  methods: {
    ...designerMapActions(['updateSection']),
    setSelectedTab(tab) {
      this.selectedTab = tab;
    },
    getBorderWidth(val) {
      this.borderWidth = val;
    },
    getBorderRadius(val) {
      this.borderRadius = val;
    },
    getBorderColor(val) {
      this.borderColor = val.color;
    },
    getBorderStyle(val) {
      this.borderStyle = val;
    },
    getTextColor(val) {
      this.textColor = val.color;
    },
    getBackgroundColor(val) {
      this.backgroundColor = val.color;
    },
    getSectionName(val) {
      this.sectionName = val;
    },
    getTitleVisibility(val) {
      this.isTitleVisible = val;
    },
    getFirstItem(item) {
      return +item.split('px')[0];
    },
    onOkClick() {
      this.updateSection({
        name: this.sectionName,
        isHidden: !this.isTitleVisible,
        styles: {
          color: this.textColor,
          backgroundColor: this.backgroundColor,
          borderColor: this.borderColor,
          borderRadius: `${this.borderRadius}px`,
          borderStyle: this.borderStyle,
          borderWidth: `${this.borderWidth}px`,
        },
      });
    },
  },
  mounted() {
    this.sectionName = this.itemTitle;
    const currentSection = this.sections.find(el => el.id === this.sectionId);
    if (currentSection && 'styles' in currentSection) {
      this.backgroundColor = currentSection.styles.backgroundColor;
      this.isTitleVisible = !currentSection.isHidden;
      this.borderColor = currentSection.styles.borderColor;
      this.borderRadius = this.getFirstItem(currentSection.styles.borderRadius);
      this.borderStyle = currentSection.styles.borderStyle;
      this.borderWidth =  this.getFirstItem(currentSection.styles.borderWidth);
      this.textColor = currentSection.styles.color;
    }
  },
};
</script>

<style scoped lang="scss">
.content {
  margin-top: 10px;
}
</style>